import { render, staticRenderFns } from "./myc-price.vue?vue&type=template&id=38ec0376"
import script from "./myc-price.vue?vue&type=script&lang=js"
export * from "./myc-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports